import React from 'react';
import './PageTitle.scss';

const PageTitle = ({title, description}) => {
    return (
        <div className='page-title'>
            <div className="container">
                <h2>Notícias & Artigos</h2>
                <p>Mantenha-se atualizado com os nossos últimos blogs e notícias e receba dicas e truques para uma saúde oral saudável.</p>
            </div>
        </div> 
    );
};

export default PageTitle;